import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { I18nProvider } from 'gunsi-auth'
import { ConfirmProvider } from './components/ConfirmDialog.jsx'
import App from './App.jsx'
import './global.css'
import './even.css'
import { applyTheme, loadThemePrefs } from './theme.js'
import { setupKbMeasure } from './measureKb.js'

setupKbMeasure()

// PWA attiva (vite-plugin-pwa autoUpdate in vite.config.js) — il vecchio
// unregister dei SW è stato rimosso il 2026-07-21.

const { theme, colorSet } = loadThemePrefs()
applyTheme(theme, colorSet)

window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
  const prefs = loadThemePrefs()
  if (prefs.theme === 'system') applyTheme('system', prefs.colorSet)
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <I18nProvider>
      <ConfirmProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ConfirmProvider>
    </I18nProvider>
  </StrictMode>
)
